import { createServerFunctions } from 'nuxt-server-fn/client'
import type * as functions from '#build/server-fn'

/**
 * Use server functions in client.
 */
export const useServerFunctions = createServerFunctions<typeof functions>("/api/__server_fn__")
